import { postRequest } from '@/utils/request';
import { getHost } from '@/utils/utils';

// 福利码相关接口，接口文档 http://wiki.wx.xunlei.cn/pages/viewpage.action?pageId=132251933、http://wiki.wx.xunlei.cn/pages/viewpage.action?pageId=144146877
// 获取福利码列表
export async function getWelfareCodeList(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/activecode/getallcodes`, data);
}

// 查询当前福利卡是否满足使用规则
export async function checkWelfareCodeLimit(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/welfarecode/checkLimit`, data);
}

// 获取符合条件的设备列表
export async function getDeviceList(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/welfarecode/legalDevices`, data);
}

// 获取福利码详情
export async function getWelfareCardDetail(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/welfarecode/codedetail`, data);
}

// 绑定设备
export async function bindDeviceWithCode(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/device/bindActCodeSn`, data);
}

// 加成卡相关接口
// 获取加成卡列表
export async function getBounsCardList(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/rights/bonus_card/list`, data);
}

// 获取符合条件的设备列表
export async function getBounsDeviceList(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/rights/bonus_card/available_devices`, data);
}

// 使用加成卡
export async function bindDeviceWithBounsCard(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/rights/bonus_card/bind_device`, data);
}

// 加成卡广告相关接口
// 获取加成卡列表
export async function getRightAdList(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/rights/recommend_list`, data);
}
